import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilFinanceiro, usuarioPerfilAtendente } from '../../usuario/usuario-perfil';


/** Acessos permitidos a tela da análise financeira */
export const acessosAnaliseFinanceira: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilFinanceiro, usuarioPerfilAtendente];

@Injectable()
export class CanActivateAnaliseFinanceira implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosAnaliseFinanceira);
    }
}
